import BreadCrumb from "Common/BreadCrumb";
import { HeaderInvAdjustmentForm } from "../components/HeaderInvAdjustmentForm";
import { DetailInvAdjustmentForm } from "../components/DetailsInvAdjustmentForm";
import { useTranslation } from "react-i18next";

export const ViewInvAdjustmentForm = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb
          title={t("InventoryAdjustment.titleListPage")}
          pageTitle={t("menu.InventoryAdjustment")}
        />
        <div className="card">
          <div className="card-body">
            <HeaderInvAdjustmentForm />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <DetailInvAdjustmentForm></DetailInvAdjustmentForm>
          </div>
        </div>
      </div>
    </>
  );
};
